import { useQuery } from '@tanstack/react-query';

import { useMarketTypeGroupsQuery } from 'features/markets/queries';
import { fetchScheduleRtpPreferences } from './api';

export const rtpQueryKeys = {
  marketTypes: ['rtp', 'marketTypes'] as const,
  schedulePrefs: (scheduleId: number | string) => ['rtp', 'schedulePrefs', scheduleId] as const,
};

/** Uses same data as useMarketTypeGroupsQuery (GET /web/market-types); load once per session. */
export function useMarketTypesQuery() {
  const query = useMarketTypeGroupsQuery();
  return {
    data: Array.isArray(query.data) ? query.data : [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useScheduleRtpPreferencesQuery(params: {
  scheduleId: number | string | null | undefined;
}) {
  const { scheduleId } = params;
  return useQuery({
    queryKey: scheduleId != null ? rtpQueryKeys.schedulePrefs(scheduleId) : (['rtp', 'schedulePrefs', 'none'] as const),
    queryFn: () => {
      if (scheduleId == null) return Promise.resolve([]);
      return fetchScheduleRtpPreferences({ schedule_id: scheduleId });
    },
    enabled: scheduleId != null,
    staleTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

